/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureCloudAccountSummary extends models.TagPostureBase {
    constructor() {
        super();
        this.setDiscriminator("TagPostureCloudAccountSummary");
    }

    getFixupPrototypeFunction() { return TagPostureCloudAccountSummary.fixupPrototype; }

    static newInstance(model: Partial<TagPostureCloudAccountSummary>): TagPostureCloudAccountSummary {
        let obj = Object.assign(new TagPostureCloudAccountSummary(), model);
        TagPostureCloudAccountSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureCloudAccountSummary>): TagPostureCloudAccountSummary {
        if (!model) return null;
        return TagPostureCloudAccountSummary.newInstance(<TagPostureCloudAccountSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureCloudAccountSummary) {
        if (!obj) return;

        models.TagPostureCloudAccountSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureCloudAccountSummary): boolean {
        if (models.TagPostureBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TagPostureCloudAccountSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (this.resource_coverage) {
            models.TagPostureResourceCoverage.fixupPrototype(this.resource_coverage);
        }
        if (this.tag_coverage) {
            for (let val of this.tag_coverage) {
                models.TagPostureTagCoverage.fixupPrototype(val);
            }
        }
        if (this.baselines) {
            for (let val of this.baselines) {
                models.TagBaselineReference.fixupPrototype(val);
            }
        }
    }

    /**
     * Time coverage was generated
     */
    created_at: Date;

    /**
     * Name of cloud account
     */
    cloud_account_name: string;

    /**
     * Resource coverage of the posture
     */
    resource_coverage: models.TagPostureResourceCoverage;

    /**
     * Tag level coverage for the posture
     */
    tag_coverage: Array<models.TagPostureTagCoverage>;

    /**
     * List of baselines that are included in this snapshot for this account
     */
    baselines: Array<models.TagBaselineReference>;

    /**
     * Whether tag remediation is allowed for this account
     */
    remediation_allowed: boolean;

}
